// frontend/src/layouts/MainLayout.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
// Importe ícones se desejar (exemplo com Heroicons)
import { ArrowLeftOnRectangleIcon, Cog6ToothIcon, CurrencyDollarIcon, CubeIcon, HomeIcon } from '@heroicons/react/24/outline';

const MainLayout = ({ children }) => {
    const { user, logout } = useAuth(); // Pega o usuário e a função logout
    const navigate = useNavigate();

    const handleLogout = () => {
        logout(); // Limpa o estado e localStorage
        navigate('/login', { replace: true }); // Redireciona para login
    };

    return (
        <div className="min-h-screen flex flex-col">
            {/* Navbar Superior */}
            <nav className="bg-gray-800 text-white shadow-md">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        {/* Logo/Nome */}
                        <div className="flex-shrink-0">
                            <Link to="/" className="font-bold text-xl">
                                Dropship Manager
                            </Link>
                        </div>

                        {/* Itens da Navbar (links e usuário/logout) */}
                        <div className="flex items-center">
                            {/* Links de Navegação (Exemplo) */}
                            <div className="hidden md:block">
                                <div className="ml-10 flex items-baseline space-x-4">
                                    <NavLink icon={HomeIcon} to="/dashboard">Dashboard</NavLink>
                                    <NavLink icon={CubeIcon} to="/products">Produtos</NavLink>
                                    <NavLink icon={CurrencyDollarIcon} to="/financials">Financeiro</NavLink>
                                    <NavLink icon={Cog6ToothIcon} to="/settings">Configurações</NavLink>
                                </div>
                            </div>

                            {/* Info do Usuário e Botão Sair */}
                            <div className="ml-4 flex items-center md:ml-6">
                                {user && (
                                    <span className="text-gray-300 text-sm mr-3 hidden sm:block">
                                        Olá, {user.email}
                                    </span>
                                )}
                                <button
                                    onClick={handleLogout}
                                    className="p-1 rounded-full text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                                    title="Sair"
                                >
                                    <span className="sr-only">Sair</span>
                                    <ArrowLeftOnRectangleIcon className="h-6 w-6" aria-hidden="true" />
                                </button>
                            </div>
                        </div>
                        {/* Menu Mobile (pode ser implementado depois com Headless UI) */}
                    </div>
                </div>
                 {/* Links de Navegação Mobile (Exemplo abaixo da navbar principal) */}
                 <div className="md:hidden bg-gray-700">
                    <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 flex justify-around">
                        <NavLink icon={HomeIcon} to="/dashboard" isMobile>Dash</NavLink>
                        <NavLink icon={CubeIcon} to="/products" isMobile>Produtos</NavLink>
                        <NavLink icon={CurrencyDollarIcon} to="/financials" isMobile>Finan.</NavLink>
                        <NavLink icon={Cog6ToothIcon} to="/settings" isMobile>Conf.</NavLink>
                    </div>
                </div>
            </nav>

            {/* Conteúdo Principal da Página */}
            <main className="flex-grow">
                {/* O componente da página atual será renderizado aqui */}
                <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                    {children}
                </div>
            </main>

             {/* Footer (Opcional) */}
             {/* <footer className="bg-gray-200 text-center p-4 text-sm text-gray-600">
                 © {new Date().getFullYear()} Dropship Manager
             </footer> */}
        </div>
    );
};

// Componente auxiliar para links de navegação (para evitar repetição)
const NavLink = ({ to, children, icon: Icon, isMobile = false }) => (
    <Link
        to={to}
        className={`flex items-center px-3 py-2 rounded-md text-sm font-medium ${
            isMobile
                ? 'text-gray-300 hover:bg-gray-700 hover:text-white flex-col text-xs' // Estilo mobile
                : 'text-gray-300 hover:bg-gray-700 hover:text-white' // Estilo desktop
        }`}
    >
        {Icon && <Icon className={`h-5 w-5 ${isMobile ? 'mb-1' : 'mr-2'}`} aria-hidden="true" />}
        {children}
    </Link>
);


export default MainLayout;